export default "__VITE_ASSET__DFoBvz2Z__"